import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { NgScrollbarModule } from "ngx-scrollbar";

@Component({
  selector: "setting",
  templateUrl: "./theme-customizer.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, NgScrollbarModule, FormsModule],
})
export class ThemeCustomizerComponent implements OnInit {
  store: any;
  showCustomizer = false;
  constructor(
    public readonly storeData: Store<any>,
    public readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.initStore();
  }

  async initStore() {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  reloadRoute() {
    window.location.reload();
    this.showCustomizer = true;
  }
}
